<template>
  <div>
    <div id="FeA">
      <div class="container">
        <h2 class="fa">
          Featured Projects <img src="../assets/Vector.png" class="img-fluid" />
        </h2>
        <div class="row mt-5">
          <div class="col-md-4 col-sm-12">
            <div class="di cl">
              <div class="">
                <img src="../assets/im2.png" class="img-fluid vt" />
              </div>

              <div class="row pt-2 pb-2 mb-5">
                <div class="col-6">
                  <p class="mt-3">Dog app</p>
                </div>
                <div class="col-6">
                  <a href="https://eden-app.netlify.app">
                    <img
                      alt="Qries"
                      src="../assets/Frame 8.png"
                      width="50px"
                      height="50px"
                    />
                  </a>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-4 col-sm-12">
            <div class="di cl">
              <div class="">
                <img src="../assets/ima.png" class="img-fluid vt" />
              </div>

              <div class="row pt-2 pb-2 mb-5">
                <div class="col-6">
                  <p class="mt-3">Zuri Chat(Teamwork)</p>
                </div>
                <div class="col-6">
                  <a href="https://www.zuri.chat/">
                    <img
                      alt="Qries"
                      src="../assets/Frame 8.png"
                      width="50px"
                      height="50px"
                    />
                  </a>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-4 col-sm-12">
            <div class="di cl">
              <div class="">
                <img src="../assets/tip.png" class="img-fluid vt" />
              </div>

              <div class="row pt-2 pb-2 mb-5">
                <div class="col-6">
                  <p class="mt-3">Zuri Chat</p>
                </div>
                <div class="col-6">
                  <a href="https://tipcalculatortrial.netlify.app/">
                    <img
                      alt="Qries"
                      src="../assets/Frame 8.png"
                      width="50px"
                      height="50px"
                    />
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row mt-5">
          <div class="col-md-4 col-sm-12">
            <div class="di cl">
              <div class="">
                <img src="../assets/im.png" class="img-fluid vt" />
              </div>

              <div class="row pt-2 pb-2 mb-5">
                <div class="col-6">
                  <p class="mt-3">Unsplash clone</p>
                </div>
                <div class="col-6">
                  <a href="https://eden-app.netlify.app">
                    <img
                      alt="Qries"
                      src="../assets/Frame 8.png"
                      width="50px"
                      height="50px"
                    />
                  </a>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-4 col-sm-12">
            <div class="di cl">
              <div class="">
                <img src="../assets/ph.png" class="img-fluid vt" />
              </div>

              <div class="row pt-2 pb-2 mb-5">
                <div class="col-6">
                  <p class="mt-3">Phoenix</p>
                </div>
                <div class="col-6">
                  <a href="https://phoenix2.netlify.app">
                    <img
                      alt="Qries"
                      src="../assets/Frame 8.png"
                      width="50px"
                      height="50px"
                    />
                  </a>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-4 col-sm-12">
            <div class="di cl">
              <div class="">
                <img src="../assets/k.png" class="img-fluid vt" />
              </div>

              <div class="row pt-2 pb-2 mb-5">
                <div class="col-6">
                  <p class="mt-3">Krd(Teamwork)</p>
                </div>
                <div class="col-6">
                  <a href="http://krdconsults.com/">
                    <img
                      alt="Qries"
                      src="../assets/Frame 8.png"
                      width="50px"
                      height="50px"
                    />
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row mt-5">
          <div class="col-md-4 col-sm-12">
            <div class="di cl">
              <div class="">
                <img src="../assets/im3.png" class="img-fluid vt" />
              </div>

              <div class="row pt-2 pb-2 mb-5">
                <div class="col-6">
                  <p class="mt-3">Fylo</p>
                </div>
                <div class="col-6">
                  <a href="https://secondproject2.netlify.app">
                    <img
                      alt="Qries"
                      src="../assets/Frame 8.png"
                      width="50px"
                      height="50px"
                    />
                  </a>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-4 col-sm-12">
            <div class="di cl">
              <div class="">
                <img src="../assets/di.png" class="img-fluid vt" />
              </div>

              <div class="row pt-2 pb-2 mb-5">
                <div class="col-6">
                  <p class="mt-3">Phoenix</p>
                </div>
                <div class="col-6">
                  <a href="https://atlantic02.netlify.app">
                    <img
                      alt="Qries"
                      src="../assets/Frame 8.png"
                      width="50px"
                      height="50px"
                    />
                  </a>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-4 col-sm-12">
            <div class="di cl">
              <div class="">
                <img src="../assets/to.png" class="img-fluid vt" />
              </div>

              <div class="row pt-2 pb-2 mb-5">
                <div class="col-6">
                  <p class="mt-3">Todo</p>
                </div>
                <div class="col-6">
                  <a href="https://toodo1.netlify.app/">
                    <img
                      alt="Qries"
                      src="../assets/Frame 8.png"
                      width="50px"
                      height="50px"
                    />
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "WorkspaceJsonFea",

  data() {
    return {};
  },

  mounted() {},

  methods: {},
};
</script>

<style lang="scss" scoped>
.fa {
  text-align: left;
  font-family: "Petrona", serif;
}
#FeA {
  /* background-color: black;
  color: white;*/
}
.cl {
  background-color: #04111f !important;
  margin-top: 0px !important;
  padding-top: 0px !important;
  color: white !important;
}
.di {
  border-radius: 2px;
}
.vt {
  border-radius: 4px !important;
}
.bo {
  margin-top: 20px;
  background-color: #04111f !important;
}
</style>